export default "__VITE_ASSET__i$WEP$Lb__"